var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacyCircledNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pharmacy-selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MCT-MVP-Pharmacies-Browse-List-Select",
    transform: "translate(-105.000000, -493.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "To-do-list/Step-Number/Active-Copy-2",
    transform: "translate(107.000000, 495.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyCircledNumber);
export default __webpack_public_path__ + "static/media/pharmacy-circled-number.bcef891e73db6ad3fda288a9b610036b.svg";
export { ForwardRef as ReactComponent };